import 'whatwg-fetch';
import 'element-remove';
import 'element-closest-polyfill';
import modalOpen from './modules/modals.js';
import sliders from './modules/sliders.js';
import select from './modules/select.js';
import showAll from './modules/show-all.js';
import burgerMenu from './modules/burger-menu.js';
import hdrSearch from './modules/hdr-search.js';
// import hdrBasket from './modules/hdr-basket.js';
import quickSearch from './modules/quick-search.js';
import typeProductCard from './modules/type-card.js';
import catalogFilter from './modules/catalog-filter.js';
import fixedMenu from './modules/menu-fixed.js';
import tabs from './modules/tabs.js';
import increaseImg from './modules/increase-img.js';
import ancors from './modules/ancors.js';
import loadFile from './modules/load-file.js';
import map from './modules/map.js';
import slideDown from './modules/slide-down.js';
import youtubeModal from './modules/youtube-modal.js';
import chosePackageProduct from './modules/choose-package-product.js';
import personalMobMenu from './modules/personal-account-mob-menu.js';
import personalDataFormChanges from './modules/personal-data-changes.js';

// тестовая связка селектов в оформлении заказа
import orderBasketSelectEvent from './modules/order-basket-select-event.js';
//END тестовая связка селектов в оформлении заказа

document.addEventListener('DOMContentLoaded', ()=>{ 
	'use strict';

	// полифил для append
	(function (arr) {
		arr.forEach(function (item) {
		  if (item.hasOwnProperty('append')) {
			return;
		  }
		  Object.defineProperty(item, 'append', {
			configurable: true,
			enumerable: true,
			writable: true,
			value: function append() {
			  var argArr = Array.prototype.slice.call(arguments),
				docFrag = document.createDocumentFragment();
			  
			  argArr.forEach(function (argItem) {
				var isNode = argItem instanceof Node;
				docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
			  });
			  
			  this.appendChild(docFrag);
			}
		  });
		});
	  })([Element.prototype, Document.prototype, DocumentFragment.prototype]);


	// полифил для forEach
	if (!Array.prototype.forEach) {
		Array.prototype.forEach = function(fn, scope) {
			for(var i = 0, len = this.length; i < len; ++i) {
				fn.call(scope, this[i], i, this);
			}
		}
	}

	// // битрикс
	// /* use: declOfNum(count, ['найдена', 'найдено', 'найдены']); */
	// function declOfNum(number, titles) {  
	//     cases = [2, 0, 1, 1, 1, 2];
	//     return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
	// }

	// //END битрикс


	// открыть модалку обратного звонка
		// modalOpen('[data-btn="call-back-hdr"]', '../modals/call-back.html');
		// modalOpen('[data-btn="call-back-hdr"]', 'https://html.knit.team/Shmetz/modals/call-back.html');

		let btnCallBackAll = document.querySelectorAll('[data-url]');


		if(btnCallBackAll[0]) {
		
			btnCallBackAll.forEach(item => {
				let btnCallBack = item.getAttribute('data-btn');
				modalOpen(`[data-btn="${btnCallBack}"]`, item.dataset.url, true);
			});
		}
	
		
	//END открыть модалку обратного звонка

	// модалка авторизации
	// modalOpen('[data-btn="enter-account"]', '../modals/enter-account.html');
	// modalOpen('[data-btn="enter-account"]', 'https://html.knit.team/Shmetz/modals/enter-account.html');

	// добавления товара в корзину на странице товара
	// modalOpen('[data-btn="add-basket"]', '../modals/add-basket.html');
	modalOpen('[data-btn="add-basket"]', 'https://html.knit.team/Shmetz/modals/add-basket.html');

	// кнопка быстрый заказ
	modalOpen('[data-btn="quick-order"]', false, true);

	// подписка на товар, сообщить о поступлении
	modalOpen('[data-btn="inform-modal"]', '/local/templates/schmetz/ajax/catalog_subscribe.php?ID=', true);

	// модальное окно выбора города
	modalOpen('[data-btn="geo-modal"]', '/local/templates/schmetz/ajax/change_region.php', true);

	// слайдеры 
	sliders();

	// селекты
	select();

	// показать все на главной
	// showAll('[data-btn="show-all-about"]', '.about-main-p', 'Подробнее');

	// показать все теги на главной
	// showAll('[data-btn="show-all-tags"]', '.tags-cloud', 'Весь список');

	// показать все теги в каталоге
	// showAll('[data-btn="show-all-asd"]', '.tags-cloud', 'Показать еще', true);

	// Показать все в ЛК, личные данные
	// showAll('[data-btn="show-all-form"]', '.form_slide-down', 'Заполните расширенные данные и получите 500 бонусов');

	// показать все на главной
	showAll('[data-btn="show-all-about"]', '.about-main-p');

	// показать все теги на главной
	showAll('[data-btn="show-all-tags"]', '.tags-cloud');

	// показать все теги в каталоге
	showAll('[data-btn="show-all-asd"]', '.tags-cloud', true);

	// показать все в ЛК бонусная система
	showAll('[data-btn="show-more"]', '.list-wrap_max-h');

	// Показать все в ЛК, личные данные
	// showAll('[data-btn="show-all-form"]', '.form_slide-down', 'Заполните расширенные данные и получите 500 бонусов');
	showAll('[data-btn="show-all-form"]', '.form_slide-down');

	// бургер
	burgerMenu();

	// поиск в шапке
	// window.fetch(hdrSearch);
	hdrSearch();

	// корзина в шапке 
	// hdrBasket('../plugins/json/basket.json');
	// hdrBasket('https://html.knit.team/Shmetz/plugins/json/basket.json');

	// быстрый поиск в шапке 
	// quickSearch('../plugins/json/search.json');
	// quickSearch('https://html.knit.team/Shmetz/plugins/json/search.json');
	quickSearch();

	// тип карточки товара в каталоге (вертикальныйЮ горизонтальный)
	typeProductCard();

	// фильтр каталога
	catalogFilter();

	// фиксированное мню
	fixedMenu();

	// табы на странице товара 
	tabs('[data-tab="product-about"]');

	// табы на странице "доставка и оплата"
	tabs('[data-tab="delivery-payment"]');

	// увеличение картинки на странице товара
	increaseImg('[data-img="increase-img"]');

	// якоря
	ancors('[data-btn="all-specifications"]', '[data-block="all-specifications"]');

	//загрузить файл
	loadFile();

	// карта страница контакты
	map();

	// видео галерея показать блоки 
	slideDown();

	// открыть модалку для видео yuotube
	youtubeModal();

	// выбор упаковки товара, корзина
	chosePackageProduct();

	// меню в ЛК мобилка
	personalMobMenu();

	// страница ЛК изменение персональных данных
	personalDataFormChanges();


	// тестовая связка селектов в оформлении заказа
	orderBasketSelectEvent();
	//END тестовая связка селектов в оформлении заказа

});